import { render, staticRenderFns } from "./SnapshotVPS.vue?vue&type=template&id=6b521b5a"
import script from "./SnapshotVPS.vue?vue&type=script&lang=js"
export * from "./SnapshotVPS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports